import gql from 'graphql-tag'

export default gql`
    query GetUserData {
        getUserData {
            customerID
            company
            companyLegalForm
            salutation
            title
            firstName
            lastName
            email
            birthdate
            telephone
            mobile
            newsletterEmail
            twoFA
            isCATVCustomer
            catvData
            contractMetaData {
                activeContractIDs
                evn {
                    contractID
                    value
                }
                sendInvoice {
                    contractID
                    sendInvoicePostal
                    sendInvoiceKupo
                }
                activeContracts {
                    contractID
                    contractStart
                    contractEnd
                    possibleContractEnd
                    lastDateForCancellation
                }
                phoneData {
                    id
                    typeID
                    cos
                    clir
                    phoneNumber
                }
            }
            connectionAddress {
                salutation
                title
                firstName
                lastName
                street
                houseNumber
                city
                zipCode
                country
            }
            billingAddress {
                salutation
                title
                firstName
                lastName
                street
                houseNumber
                city
                zipCode
                country
            }
            deliveryAddress {
                salutation
                title
                firstName
                lastName
                street
                houseNumber
                city
                zipCode
                country
            }
            accountHolderAddress {
                salutation
                title
                firstName
                lastName
                street
                houseNumber
                city
                zipCode
                country
            }
            offers
            tips
            bankData {
                currentID
                accountHolder
                iban
                isTransfer
                bic
                creditorID
                Mandatsreferenz
            }
        }
    }
`
